export default {
  stringEmpty: str => {
    return str === '' || str === null || str === undefined
  },
  isValidDate: str => {
    var date_regex = /^(0[1-9]|1[0-2])\/(19|20)\d{2}$/
    return date_regex.test(str)
  },
  arrayEmpty: arr => {
    return arr.length === 0 || arr.indexOf('') !== -1
  },
  isEmail: str => {
    return RegExp('^[A-Za-z0-9_!#$%&*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$').test(str)
  },
  isValidPassword: str => {
    return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~*])(?=.{10,})').test(str)
  },
  isSamePassword: (password, passwordConfirmation) => {
    return password === passwordConfirmation
  },
  isNumberBetween: (num, minNum = 0, maxNum = Number.MAX_VALUE) => {
    return !isNaN(num) && num >= minNum && num <= maxNum
  },
  isNumber: num => {
    if (num !== null) {
      if (typeof num === 'string') {
        num = num.replace(',', '.')
        return !isNaN(num)
      } else if (typeof num === 'number') {
        return true
      }
    }
    return false
  },
  isNocCode: str => {
    return str !== null && !isNaN(str) && str.length === 5
  },
  stringContainsLinkedInLink: str => {
    return (
      isWebsiteUrl(str) && str.startsWith('https://') && str.indexOf('linkedin.com/') !== -1 && !str.endsWith('linkedin.com/')
    )
  },
  isWebsiteUrl: isWebsiteUrl
}

function isWebsiteUrl(str) {
  return RegExp(
    '^((ftp|http|https)://)(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+((?!.*[/]{2})+.[a-zA-Z-0-9_+/]+)+((/)[w#]+)*(/w+?[a-zA-Z0-9_]+=w+(&[a-zA-Z0-9_]+=w+)*)?$'
  ).test(str)
}
